<prlw-profile-organization-tab-ui
  [organization]="organization"
  [areRegulationsSigned]="areRegulationsSigned"
></prlw-profile-organization-tab-ui>
